module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB2001-f1691fb7e3f93584cd63c417aeaaf1a5.png";